export const typeDiecast = [


    {
        "id": 1, "title": "Standard Diecast"
    },
    {
        "id": 2, "title": "Watertight Light Duty"
    },
    {
        "id": 3, "title": "Watertight Heavy Duty"
    },
    {
        "id": 4, "title": "Other"
    },

]

export const standardDiecast = [
    {
        id: 0,
        'title': '1590H'
    },
    {
        id: 1,
        'title': '1590G'
    },
    {
        id: 2,
        'title': '1590BB'
    },
    {
        id: 3,
        'title': '1590V'
    },
    {
        id: 4,
        'title': '1590N1'
    },
    {
        id: 5,
        'title': '1590KK'
    },
    {
        id: 6,
        'title': '1590P1'
    },
    {
        id: 7,
        'title': '1590F'
    },
    {
        id: 8,
        'title': '1590EE'
    },
    {
        id: 9,
        'title': '1590BX'
    },
]


export const watertightLightDuty = [
    {
        id: 0,
        'title': '1590WH'
    },
    {
        id: 1,
        'title': '1590WG'
    },
    {
        id: 2,
        'title': '1590WBB'
    },
    {
        id: 3,
        'title': '1590WV'
    },
    {
        id: 4,
        'title': '1590WN1'
    },
    {
        id: 5,
        'title': '1590WKK'
    },
    {
        id: 6,
        'title': '1590WP1'
    },
    {
        id: 7,
        'title': '1590WF'
    },
    {
        id: 8,
        'title': '1590WEE'
    },
    {
        id: 9,
        'title': '1590WBX'
    },
]

export const watertightHeavyDuty = [

    {
        id: 2,
        'title': '1590Z060'
    },
    {
        id: 3,
        'title': '1590Z100'
    },
    {
        id: 4,
        'title': '1590Z120'
    },
    {
        id: 5,
        'title': '1590Z130'
    },
    {
        id: 6,
        'title': '1590Z150'
    },
    {
        id: 7,
        'title': '1590Z155'
    },
    {
        id: 8,
        'title': '1590Z231'
    },
    {
        id: 9,
        'title': '1590Z162'
    },
]
